import { Link } from "react-router-dom";
const SidebarMenu = ({
  providerData,
  clinicData,
  setOpen,
  open,
  profileCompletionData,
}) => {
  return (
    //     <>
    //       {providerData?.providerVerificationStatus === "VERIFIED_AND_APPROVED" && (
    //         <>
    //           <Link to="/bank-details" onClick={() => setOpen(!open)}>
    //             Bank Details
    //           </Link>
    //           <Link to="/change-password" onClick={() => setOpen(!open)}>
    //             Change Password
    //           </Link>
    //         </>
    //       )}
    //       {profileCompletionData?.personalInfo === true && (
    //         <Link to="/personal-info" onClick={() => setOpen(!open)}>
    //           Personal Information
    //         </Link>
    //       )}
    //       {profileCompletionData?.professionalInfo === true && (
    //         <Link to="/professional-info" onClick={() => setOpen(!open)}>
    //           Professional Information
    //         </Link>
    //       )}
    //       {profileCompletionData?.serviceInfo === true && (
    //         <Link to="/service-info" onClick={() => setOpen(!open)}>
    //           Service Information
    //         </Link>
    //       )}

    //       <Link to="/billing" onClick={() => setOpen(!open)}>
    //         Billing & Payments
    //       </Link>

    //       {providerData?.providerVerificationStatus === "VERIFIED_AND_APPROVED" && (
    //         <>
    //           <Link to="/roster" onClick={() => setOpen(!open)}>
    //             Roster
    //           </Link>

    //           <Link to="/vacation" onClick={() => setOpen(!open)}>
    //             Vacation/Block Calander
    //           </Link>
    //           {clinicData?.clinicProvider?.length > 1 && (
    //             <Link to="/clinics" onClick={() => setOpen(!open)}>
    //               Switch Clinic
    //             </Link>
    //           )}
    //         </>
    //       )}

    //       {/* {providerData &&
    //       providerData?.userType !== "REGISTRED_PROVIDER" ? (
    //         <Link to="/inbox" onClick={() => setOpen(!open)}>
    //           Video Review
    //         </Link>
    //       ) : ( */}
    //         <Link to="/inbox" onClick={() => setOpen(!open)}>
    //           Inbox
    //         </Link>
    //       {/* )} */}

    //  <Link to="/video-review" onClick={() => setOpen(!open)}>
    //            Video Review
    //         </Link>

    //     </>

    <>
      {providerData?.providerVerificationStatus === "VERIFIED_AND_APPROVED" &&  !providerData?.scribeClinicId && (
        <Link to="/bank-details" onClick={() => setOpen(!open)}>
          Bank Details
        </Link>
      )}

      <Link to="/change-password" onClick={() => setOpen(!open)}>
        Change Password
      </Link>

      {providerData?.providerVerificationStatus === "VERIFIED_AND_APPROVED" && (
        <Link to="/inbox" onClick={() => setOpen(!open)}>
          Inbox
        </Link>
      )}

      {/* <Link to="/billing" onClick={() => setOpen(!open)}>
       Payments Report
      </Link> */}

      {profileCompletionData?.professionalInfo === true &&
        profileCompletionData?.personalInfo === true &&
        profileCompletionData?.serviceInfo === true &&
        providerData?.providerVerificationStatus ===
          "VERIFIED_AND_APPROVED" && !providerData?.scribeClinicId && (
          <Link to="/billing" onClick={() => setOpen(!open)}>
            Payments
          </Link>
        )}

      {profileCompletionData?.personalInfo === true &&
        providerData?.providerVerificationStatus ===
          "VERIFIED_AND_APPROVED" && (
          <Link to="/personal-info" onClick={() => setOpen(!open)}>
            Personal Information
          </Link>
        )}

      {profileCompletionData?.professionalInfo === true &&
        providerData?.providerVerificationStatus ===
          "VERIFIED_AND_APPROVED" && (
          <Link to="/professional-info" onClick={() => setOpen(!open)}>
            Professional Information
          </Link>
        )}

      {providerData?.providerVerificationStatus === "VERIFIED_AND_APPROVED" && (
        <Link to="/roster" onClick={() => setOpen(!open)}>
          Roster
        </Link>
      )}

      {profileCompletionData?.serviceInfo === true &&
        providerData?.providerVerificationStatus ===
          "VERIFIED_AND_APPROVED" && (
          <Link to="/service-info" onClick={() => setOpen(!open)}>
            Service Information
          </Link>
        )}

      {providerData?.providerVerificationStatus === "VERIFIED_AND_APPROVED" && (
        <Link to="/vacation" onClick={() => setOpen(!open)}>
          Vacation/Block Calander
        </Link>
      )}

      {/* {profileCompletionData?.professionalInfo === true &&
        profileCompletionData?.personalInfo === true &&
        profileCompletionData?.serviceInfo === true && (
          <Link to="/video-review" onClick={() => setOpen(!open)}>
            merago.ai
          </Link>
        )} */}

      {/* {!providerData?.isScribeEnabled &&
        profileCompletionData?.professionalInfo === true &&
        profileCompletionData?.personalInfo === true &&
        profileCompletionData?.serviceInfo === true && (
          <Link to="/ai/intake" onClick={() => setOpen(!open)}>
            Intake
          </Link>
        )} */}

      {providerData?.providerVerificationStatus === "VERIFIED_AND_APPROVED" &&
        clinicData?.clinicProvider?.length > 1 && (
          <Link to="/clinics" onClick={() => setOpen(!open)}>
            Switch Clinic
          </Link>
        )}
    </>
  );
};

export default SidebarMenu;
